export const POST_CREATE_REQUEST = 'POST_CREATE_REQUEST'
export const POST_CREATE_SUCCESS = 'POST_CREATE_SUCCESS'
export const POST_CREATE_FAIL = 'POST_CREATE_FAIL'
export const POST_CREATE_CLEAR = 'POST_CREATE_CLEAR'

export const POSTS_LIST_REQUEST = 'POSTS_LIST_REQUEST'
export const POSTS_LIST_SUCCESS = 'POSTS_LIST_SUCCESS'
export const POSTS_LIST_FAIL = 'POSTS_LIST_FAIL'

export const GET_POST_REQUEST = 'GET_POST_REQUEST'
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS'
export const GET_POST_FAIL = 'GET_POST_FAIL'

export const DELETE_POST_REQUEST = 'DELETE_POST_REQUEST'
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS'
export const DELETE_POST_FAIL = 'DELETE_POST_FAIL'